export function linkToAnonymousResourcesHubPage() {
  return `/resources`;
}
